// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-1UaOLnWJ","sider":"sider-2EU_h9G4","stock_box":"stock_box-2IsxmqSY clearfix","sider_list":"sider_list-35gy9MQh"};